import { render, staticRenderFns } from "./CateView.vue?vue&type=template&id=713ce9b1&"
import script from "./CateView.vue?vue&type=script&lang=js&"
export * from "./CateView.vue?vue&type=script&lang=js&"
import style0 from "./CateView.vue?vue&type=style&index=0&id=713ce9b1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports